module.exports = __webpack_public_path__ + "img/genswell_4_1.e0206547.png";